import React, { useState } from "react";

const SITE_URL = "https://ajeshbs.me";

const ShareButtons = ({ modelName }) => {
    const [copied, setCopied] = useState(false);

    const shareUrl = `${SITE_URL}?model=${encodeURIComponent(modelName)}`;
    const shareText = `Check out this 3D CAD model: ${modelName} — designed in Siemens NX`;

    const shareLinks = [
        {
            name: "LinkedIn",
            icon: "fa-linkedin",
            color: "#0077b5",
            url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
        },
        {
            name: "X (Twitter)",
            icon: "fa-twitter",
            color: "#1da1f2",
            url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
        },
        {
            name: "WhatsApp",
            icon: "fa-whatsapp",
            color: "#25d366",
            url: `https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`,
        },
    ];

    const handleCopyLink = async (e) => {
        e.stopPropagation();
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = shareUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    const handleShareClick = (e, url) => {
        e.stopPropagation();
        window.open(url, "_blank", "noopener,noreferrer,width=600,height=400");
    };

    return (
        <div className="share-buttons" onClick={(e) => e.stopPropagation()}>
            {shareLinks.map((link, i) => (
                <button
                    key={i}
                    className="share-btn"
                    title={`Share on ${link.name}`}
                    style={{ "--share-color": link.color }}
                    onClick={(e) => handleShareClick(e, link.url)}
                >
                    <i className={`fa ${link.icon}`}></i>
                </button>
            ))}
            <button
                className={`share-btn copy-btn ${copied ? "copied" : ""}`}
                title="Copy link"
                onClick={handleCopyLink}
            >
                <i className={`fa ${copied ? "fa-check" : "fa-link"}`}></i>
                {copied && <span className="copy-tooltip">Copied!</span>}
            </button>
        </div>
    );
};

export default ShareButtons;
